import { memo } from "react";

import { RouteType } from "../../../router/enums";
import { routes } from "../../../router/routes";
import { MainRoute } from "../../../router/types";
import { Grid } from "../../Grid";
import { FormType } from "../../enums";

import { RoutesContainer } from "./RoutesContainer";
import styles from "./Sidebar.module.scss";

type SidebarProps = {
  readonly type: FormType;
  readonly currentRoute: string;
};

const getNavigationByType = (formType: FormType) => {
  const filteredRoutes = routes.filter(
    ({ type }) => type === RouteType.MAIN_ROUTE
  ) as Array<MainRoute>;

  return filteredRoutes.find(({ id }) => id === formType);
};

export const Sidebar = memo<SidebarProps>(({ type, currentRoute }) => {
  const navigation = getNavigationByType(type);

  if (!navigation?.routes) return null;

  return (
    <Grid
      item
      className={styles.container}
      xs={12}
      md={4}
      spacingInnerRight={{ md: 10, xs: 0 }}
      spacingBottom={{ xs: 2 }}
    >
      <RoutesContainer currentRoute={currentRoute} routes={navigation.routes} />
    </Grid>
  );
});
